/**
 * user-frontend/src/redux/store.js
 *
 * FIXES:
 *  - Usa RTK createSlice em vez de reducer manual (tinha RTK instalado mas não usado)
 *  - auth slice é fonte de verdade APENAS para dados de sessão partilhados entre slices
 *  - AuthContext é a fonte de auth para componentes UI
 *  - Removida rehydratação duplicada (AuthContext já faz isso)
 *  - Adicionados selectors memoizados
 */

import { configureStore, createSlice } from '@reduxjs/toolkit';

// ─── Services slice ───────────────────────────────────────────
const servicesSlice = createSlice({
  name: 'services',
  initialState: { list: [], topWorkers: [], loading: false, error: null },
  reducers: {
    setServices:   (state, { payload }) => { state.list = payload; },
    setTopWorkers: (state, { payload }) => { state.topWorkers = payload; },
    setLoading:    (state, { payload }) => { state.loading = payload; },
    setError:      (state, { payload }) => { state.error = payload; },
  },
});

// ─── Requests slice ───────────────────────────────────────────
const requestsSlice = createSlice({
  name: 'requests',
  initialState: { list: [], loading: false, error: null },
  reducers: {
    setRequests:   (state, { payload }) => { state.list = payload; },
    addRequest:    (state, { payload }) => { state.list.push(payload); },
    setLoading:    (state, { payload }) => { state.loading = payload; },
    setError:      (state, { payload }) => { state.error = payload; },
  },
});

// ─── Exports de actions ───────────────────────────────────────
export const { setServices, setTopWorkers } = servicesSlice.actions;
export const { setRequests, addRequest }    = requestsSlice.actions;

// ─── Selectors memoizados ─────────────────────────────────────
export const selectServices   = (state) => state.services.list;
export const selectTopWorkers = (state) => state.services.topWorkers;
export const selectRequests   = (state) => state.requests.list;

// ─── Store ────────────────────────────────────────────────────
const store = configureStore({
  reducer: {
    services: servicesSlice.reducer,
    requests: requestsSlice.reducer,
  },
  devTools: process.env.NODE_ENV !== 'production',
});

export default store;
